import Template from './experience_price.njk';
import _ from "underscore";
import Marionette from "backbone.marionette";

export default Marionette.View.extend({
  template: Template,
    modelEvents: {
        "change": "render"
    },

    calculateSchedulePrice() {
        var date = this.options.start.format("YYYY-MM-DD");
        var day = this.options.start.day();
        var time = parseInt(this.options.start.format("Hmm"));

        var delta;

        if (this.model.get("schedules")) {
            _.each(this.model.get("schedules"), (schedule) => {
                if (schedule.type !== "available") {
                    return;
                }

                if (schedule.start && schedule.start > date) {
                    return;
                }

                if (schedule.end && schedule.end < date) {
                    return;
                }

                if ((schedule.repeat == "weekly" && schedule.days.indexOf(day) > -1) ||
                    (schedule.repeat == "custom" && schedule.dates.indexOf(date) > -1)) {

                    if (schedule.times && schedule.times.indexOf(time) > -1) {
                        if (_.isUndefined(delta) || schedule.priceDelta > delta) {
                            delta = schedule.priceDelta;
                        }
                    }
                }
            });
        }

        if (_.isUndefined(delta)) {
            delta = 0;
        }

        return this.model.get("price") + delta;
    },

    templateContext: function () {
        var price = this.calculateSchedulePrice(),
            currency = this.model.get('currency'),
            formattedPrice;

        if (price && currency) {
            formattedPrice = price.toLocaleString('en', {style: 'currency', currency: currency});
        }
        return {
            formattedPrice: formattedPrice
        }
    }
});



// WEBPACK FOOTER //
// ./src/js/view/experience_price.js